import React from 'react';
import { Link } from 'react-router';
import { toModernAppSectionUrl } from '../../utils/paths';
const ApplicationLink = ({ href, children, ...props }) => {
    const destination = toModernAppSectionUrl(href);
    if (destination.startsWith('/') && !destination.startsWith('//')) {
        return React.createElement(Link, { to: destination, ...props }, children);
    }
    return React.createElement("a", { href: destination, ...props }, children);
};
export default ApplicationLink;
